
import {defineComponent, ref} from 'vue'
import { useToast } from "vue-toastification"
import db from '../db'

export default defineComponent({
    name: "Auth",
    setup(){
        const toast = useToast();
        const mode = ref<string>('signin')
        const email = ref<string>('')
        const pass = ref<string>('')

        const errorHandle = (err: any): void => {
            const e = err.code.split('/')[1]
            switch (e){
                case 'invalid-email':
                    toast.warning('請輸入正確信箱')
                    break
                case 'weak-password':
                    toast.warning('密碼至少需 6 位字符')
                    break
                case 'user-not-found':
                    toast.error('查無此使用者，請確認信箱是否輸入錯誤')
                    break
                case 'wrong-password':
                    toast.error('密碼錯誤，請確認是否輸入錯誤')
                    break
            }
        }

        const signup = (): void => {
            if(email.value.trim()===''){
                toast.warning('請輸入信箱')
                return
            }
            else if( pass.value.trim()===''){
                toast.warning('請輸入密碼')
                return
            }
            const promise = db.auth().createUserWithEmailAndPassword(email.value, pass.value)
            promise.then(()=>{
                toast.info("註冊成功!")
            }).catch(err => {
                errorHandle(err)
            })
        }

        const signin = (): void => {
            const promise = db.auth().signInWithEmailAndPassword(email.value, pass.value)
            promise.then(()=>{
                toast.info("登入成功!")
            }).catch(err=>{
                errorHandle(err)
            })
        }

        return{
            mode,
            errorHandle,
            signup,
            signin,
            email,
            pass,
        }
    }
})
